const home = {
  title: 'Home',
  language: 'Language',
  allLanguages: 'All languages',
  languageFilter: 'Filter by language',
  languagesSelected: '{{count}} selected',
  languages: {
    en: 'English',
    sl: 'Slovenian',
    hr: 'Croatian',
  },

  loadingTemplates: 'Loading templates...',
  noTemplates: 'No templates available',
  noTemplatesForLanguage: 'No templates available for this language',
  noTemplatesForLanguageDescription:
    'Create a template in this language to get started.',
  selectTemplate: 'Select a template',
  selectTemplateDescription:
    'Which template do you want to use for the transcription?',

  start: 'Start recording',
  dropAudioHere: 'Drop audio file here',
  uploadAudio: 'Upload audio',
  uploadAndGenerate: 'Upload audio',
  uploading: 'Uploading...',
  uploadingAndGenerating: 'Uploading...',
  stop: 'Stop',
  saving: 'Saving...',
  delete: 'Delete',

  resume: 'Resume transcription',
  cancel: 'Cancel',
  continue: 'Continue',
  transcription: 'Transcription',
  transcriptionEmpty: 'No transcription yet',
  segmentBreaks: 'Segment breaks',
  paused: 'Paused',
  extractData: 'Prepare report',
  extractingData: 'Generating document',
  extractingDataDescription: "This shouldn't take long...",
  transcribingData: 'Transcribing audio',
  transcribingDataDescription: 'Converting audio to text...',

  errorLoadingTemplates: 'Error loading templates',
  retry: 'Retry',
  createTemplate: 'Create template',

  stats: {
    word: 'word',
    words: 'words',
    character: 'character',
    characters: 'characters',
    token: 'token',
    tokens: 'tokens',
  },

  sectionGuidance: {
    analyzing: 'Analyzing...',
    suggestion: 'Suggestion',
    analysisFailed: 'Section analysis failed',
    analysisFailedDescription:
      'Unable to analyze sections. Recording will continue.',
  },

  errors: {
    networkNotConnected: {
      title: 'No Internet Connection',
      description: 'An internet connection is required to use this app.',
    },
    get_user_media_failed: {
      title: 'Microphone Access Denied',
      description:
        'Please allow microphone access in your browser settings to continue.',
    },
    api_key_fetch_failed: {
      title: 'Authentication Failed',
      description:
        'We could not verify your session. Please refresh the page and try again.',
    },
    queue_limit_exceeded: {
      title: 'Network Connection Unstable',
      description:
        'Your internet connection is too slow to upload audio in real-time. Transcription stopped.',
    },
    websocket_error: {
      title: 'Connection Lost',
      description:
        'Lost contact with the transcription server. Please check your internet connection.',
    },
    media_recorder_error: {
      title: 'Recording Error',
      description:
        'Your browser stopped the recording unexpectedly. Please try again.',
    },
    api_error: {
      title: 'Server Error',
      description: 'The transcription service reported an error: {{message}}',
    },
    default: {
      title: 'An Error Occurred',
      description: 'Something went wrong. Please try again.',
    },
  },
};

export default home;
